// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { useToastStore } from '@/store'

export function useToast() {
  const { toasts, addToast, removeToast } = useToastStore()

  return {
    toasts,
    toast: {
      success: (msg: string) => addToast(msg, 'success'),
      error:   (msg: string) => addToast(msg, 'error'),
      warning: (msg: string) => addToast(msg, 'warning'),
      info:    (msg: string) => addToast(msg, 'info'),
    },
    remove: removeToast,
  }
}
